export default "__VITE_ASSET__43356e34__"